module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-45.615d94ac.png";